import { render, staticRenderFns } from "./filesFranchise.vue?vue&type=template&id=37e8bc59&scoped=true&lang=html&"
import script from "./filesFranchise.vue?vue&type=script&lang=js&"
export * from "./filesFranchise.vue?vue&type=script&lang=js&"
import style0 from "./filesFranchise.vue?vue&type=style&index=0&id=37e8bc59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e8bc59",
  null
  
)

export default component.exports